import React, { useEffect, useState } from "react";
import axios from "../../api/axiosinstance";
import { useParams } from "react-router-dom";
import TestingApi from "../../api/TestingApi";

function ProjectDetails() {
  const { id } = useParams();

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [projectStatus, setProjectStatus] = useState("");

  const [testers, setTesters] = useState([]);

  const [testerId, setTesterId] = useState("");

  const fetchDetails = async () => {
    try {
      const res = await axios.get(`/projects/${id}`);

      if (res.code === 200) {
        setData(res.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const loadTesters = async () => {
    try {
      const res = await TestingApi.getUsers();

      if (res.code === 200) {
        const testerUsers = res.data.filter((item) =>
          item.roleId?.role?.toLowerCase().includes("tester"),
        );

        setTesters(testerUsers);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const assignTester = async () => {
    try {
      const res = await TestingApi.assignTester(id, testerId);

      if (res.code === 200) {
        alert("Tester Assigned");

        fetchDetails();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const sendForTesting = async () => {
    try {
      const res = await TestingApi.readyForTesting(id);

      if (res.code === 200) {
        alert("Project Sent For Testing");

        fetchDetails();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateStatus = async () => {
    try {
      const res = await axios.put(`/projects/update-status/${id}`, {
        projectStatus,
      });

      if (res.code === 200) {
        alert("Status Updated");

        fetchDetails();
      }
    } catch (err) {
      console.log(err);

      alert("Failed to update");
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [id]);

  useEffect(() => {
    loadTesters();
  }, []);

  useEffect(() => {
    if (data?.project?.projectStatus) {
      setProjectStatus(data.project.projectStatus);
    }
  }, [data]);

  if (loading) {
    return <div className="content">Loading...</div>;
  }

  if (!data) {
    return <div className="content">Project Not Found</div>;
  }

  return (
    <div className="content">
      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">{data.project?.projectName}</h2>

          <p className="text-muted">Complete Client & Project Overview</p>
        </div>

        <div className="d-flex gap-2">
          <span className="badge bg-danger fs-12 px-3 py-2">
            {data.project?.priority}
          </span>

          <span className="badge bg-warning text-dark fs-12 px-3 py-2">
            {data.project?.projectStatus}
          </span>
        </div>
      </div>

      <div className="row">
        {/* LEFT SIDE */}

        <div className="col-lg-8">
          {/* CLIENT DETAILS */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Client Information</h5>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <h6>Client Name</h6>

                  <p>{data.project?.leadId?.name}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Email</h6>

                  <p>{data.project?.leadId?.email || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Phone</h6>

                  <p>{data.project?.leadId?.phone || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Business</h6>

                  <p>{data.project?.leadId?.company_name || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Lead Source</h6>

                  <p>{data.project?.leadId?.sourceId?.source || "N/A"} </p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Assigned Sales Person</h6>

                  <p>{data.project?.leadId?.assignedTo?.name || "N/A"}</p>
                </div>
              </div>
            </div>
          </div>

          {/* PROJECT DETAILS */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Project Information</h5>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <h6>Assigned Developer</h6>

                  <p>{data.project?.assignedDeveloper?.name}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <h6>Deadline</h6>

                  <p>
                    {data.project?.deadline
                      ? new Date(data.project.deadline).toLocaleDateString()
                      : "N/A"}
                  </p>
                </div>

                <div className="col-md-12">
                  <h6>Internal Notes</h6>

                  <div className="border rounded p-3 bg-light">
                    {data.project?.notes || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FOLLOWUPS */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Followups</h5>
            </div>

            <div className="card-body">
              {data.followups?.length === 0 ? (
                <p className="text-muted">No Followups Found</p>
              ) : (
                data.followups.map((item) => (
                  <div key={item._id} className="border rounded p-3 mb-3">
                    {/* HEADER */}

                    <div className="d-flex justify-content-between">
                      <div>
                        <strong>{item.userId?.name}</strong>

                        <div className="mt-1">
                          <span className="badge bg-danger me-2">
                            {item.disposition}
                          </span>

                          {item.sub_disposition && (
                            <span className="badge bg-dark">
                              {item.sub_disposition}
                            </span>
                          )}
                        </div>
                      </div>

                      <small>{new Date(item.createdAt).toLocaleString()}</small>
                    </div>

                    {/* REMARKS */}

                    {item.remarks && (
                      <div className="mt-3">📝 {item.remarks}</div>
                    )}

                    {/* PAYMENT */}

                    {item.payment_amount > 0 && (
                      <div className="mt-3">
                        💰 Amount: ₹{item.payment_amount}
                      </div>
                    )}

                    {/* PACKAGE */}

                    {item.packageId?.packageName && (
                      <div className="mt-2">
                        📦 Package:
                        {item.packageId.packageName}
                      </div>
                    )}

                    {/* COMMITMENTS */}

                    {item.commitments?.length > 0 && (
                      <div className="mt-3">
                        <strong>Commitments</strong>

                        {item.commitments.map((c, i) => (
                          <div key={i} className="border rounded p-2 mt-2">
                            <div>{c.moduleName}</div>

                            <small>{c.description}</small>

                            <div className="text-success">₹{c.price}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* DYNAMIC DETAILS */}

                    {item.fill_details &&
                      Object.keys(item.fill_details).length > 0 && (
                        <div className="mt-3">
                          <strong>Additional Details</strong>

                          {Object.entries(item.fill_details).map(
                            ([key, value]) => (
                              <div key={key}>
                                {key}: {value}
                              </div>
                            ),
                          )}
                        </div>
                      )}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}

        <div className="col-lg-4">
          {/* STATUS */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Project Status</h5>
            </div>

            <div className="card-body">
              <select
                className="form-select mb-3"
                value={projectStatus}
                onChange={(e) => setProjectStatus(e.target.value)}
              >
                <option value="pending">Pending</option>

                <option value="in_progress">In Progress</option>

                <option value="testing">Testing</option>

                <option value="completed">Completed</option>
              </select>
              <button className="btn btn-primary w-100" onClick={updateStatus}>
                Update Status
              </button>{" "}
              <button
                className="btn btn-warning w-100 mt-2"
                onClick={sendForTesting}
              >
                Send For Testing
              </button>
              <select
                className="form-select mb-2"
                value={testerId}
                onChange={(e) => setTesterId(e.target.value)}
              >
                <option value="">Select Tester</option>

                {testers.map((tester) => (
                  <option key={tester._id} value={tester._id}>
                    {tester.name}
                  </option>
                ))}
              </select>
              <button className="btn btn-success w-100" onClick={assignTester}>
                Assign Tester
              </button>
            </div>
          </div>

          {/* DOCUMENTS */}

          {/* DOCUMENTS */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">Documents</h5>
            </div>

            <div className="card-body">
              {data.documents?.length === 0 ? (
                <p className="text-muted">No Documents</p>
              ) : (
                data.documents.map((doc) => (
                  <div key={doc._id} className="border rounded p-3 mb-3">
                    <div className="fw-semibold mb-3">
                      📄 {doc.documentNumber}
                    </div>

                    <div className="d-flex gap-2">
                      {/* VIEW */}

                      <button
                        className="btn btn-primary btn-sm w-50"
                        onClick={() =>
                          window.open(
                            `http://localhost:5000/api/v1/documents/download/${doc._id}`,
                            "_blank",
                          )
                        }
                      >
                        View
                      </button>

                      {/* DOWNLOAD */}

                      <a
                        href={`http://localhost:5000/api/v1/documents/download/${doc._id}`}
                        download
                        className="btn btn-outline-dark btn-sm w-50"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetails;
